import "./product-details-title.scss";
import { EventBus, Events } from "jiffy-store";
import { isMadeSamplePdp } from "components/jiffy/product-details/customizable-made-page-utils";

const colorUpdateObserver = $context => {
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
    if (isMadeSamplePdp()) {
      $context.textContent = `${color} - Sample`;
    } else {
      $context.textContent = color;
    }
  });
};

export default () => {
  const $titleColorName = document.querySelector(`.js-product-details-title__color-name`);
  if (!$titleColorName) return;

  colorUpdateObserver($titleColorName);
};
